import React, { Component } from "react";
import {
  Row,
  Col,
  Button,
  Accordion,
  Card,
  FormControl,
  Form,
  CardGroup,
  CardDeck,
  Nav,
} from "react-bootstrap";
import api from "../../api";
import axios from "axios";
import Switch from "react-switch";

export default class ChatHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      _id: "5f5160d8a10793db1a28a15d",
      isLoading: false,
      chat_history: [],
      chat: [],
    };
  }

  componentDidMount() {
    var biz_id = "5f5160d8a10793db1a28a15d";
    api.getChatHistoryById(biz_id).then(
      (res) => {
        console.log("Response:", res);
        let data = res.data;
        var chat_data = data.data.chat;
        for (var i in chat_data) {
          chat_data[i] = JSON.parse(chat_data[i]);
        }
        console.log("chat_data", chat_data);
        this.setState({
          chat_history: data.data,
          chat: chat_data,
        });
        console.log("chat", this.state);
      },
      (error) => {
        console.log("error", error);
      }
    );
  }

  render() {
    const { chat_history, chat } = this.state;
    return (
      <div className="gs-container">
        <Card>
          <Card.Header>
            <Nav variant="tabs" defaultActiveKey="#first">
              <Nav.Item>
                <Nav.Link href="#first">Resolved</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link href="#link">Unresolved</Nav.Link>
              </Nav.Item>
            </Nav>
          </Card.Header>
          <Card.Body>
            <Card.Title></Card.Title>
            <Card.Text>
              {chat.map((item, index) => (
                <div>
                  <Row className="">
                    <Col sm="auto">
                      <label className="text-muted">User:</label>
                    </Col>
                    <Col>
                      <label>{item.user}</label>
                    </Col>
                  </Row>

                  <Row className="">
                    <Col sm="auto">
                      <label className="text-muted">Bot:</label>
                    </Col>
                    <Col>
                      <label>{item.bot}</label>
                    </Col>
                  </Row>
                </div>

                // <span>User: <p>{item.user}</p></span>
              ))}
            </Card.Text>
            <Row className="">
              <Col sm="auto">
                <Form>
                  <Form.Group controlId="exampleForm.ControlTextarea1">
                    <Form.Control as="textarea" placeholder="Enter message here..." rows="3" />
                  </Form.Group>
                </Form>
              </Col>
              <Col>
                <Button variant="primary">Send</Button>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </div>
    );
  }
}
